// NikoSafe Connect Mock Data
// This file contains all mock data for the frontend-only implementation
// Will be replaced with real backend API calls during integration

export const features = [
  {
    id: 1,
    icon: 'Shield',
    title: 'Infection Prevention Hub',
    description: 'Real-time surveillance, outbreak tracking, and evidence-based protocols at your fingertips. From CLABSI to CAUTI prevention, all in one place.',
    category: 'infection-prevention'
  },
  {
    id: 2,
    icon: 'AlertTriangle',
    title: 'Patient Safety Events',
    description: 'Streamlined incident reporting, root cause analysis, and corrective action tracking. Turn every event into a learning opportunity.',
    category: 'patient-safety'
  },
  {
    id: 3,
    icon: 'ClipboardCheck',
    title: 'Quality Audits & Tracers',
    description: 'Survey-ready documentation, tracer workflows, and compliance tracking. Walk into any accreditation survey with confidence.',
    category: 'quality'
  },
  {
    id: 4,
    icon: 'TrendingUp',
    title: 'Performance Improvement',
    description: 'PI project management, PDSA cycles, and outcome tracking. Connect every initiative to measurable results.',
    category: 'improvement'
  },
  {
    id: 5,
    icon: 'FileSearch',
    title: 'Policy & Procedure Access',
    description: 'Instant access to facility policies, clinical guidelines, and evidence-based standards. No more hunting through binders.',
    category: 'policies'
  },
  {
    id: 6,
    icon: 'BarChart3',
    title: 'Executive Dashboards',
    description: 'Real-time KPIs, trend analysis, and board-ready reports. From unit-level metrics to enterprise-wide views.',
    category: 'analytics'
  }
];

export const benefits = [
  {
    role: 'Frontline Staff',
    icon: 'Stethoscope',
    color: 'teal',
    items: [
      'Get instant answers to clinical questions',
      'Report incidents in under 60 seconds',
      'Access policies without leaving the unit',
      'Know exactly what to do during an outbreak'
    ]
  },
  {
    role: 'Department Heads',
    icon: 'Users',
    color: 'green',
    items: [
      'Track unit-level safety metrics in real-time',
      'Manage audits and follow-up actions',
      'Coordinate PI projects across teams',
      'Receive alerts before issues escalate'
    ]
  },
  {
    role: 'Quality & Safety Leaders',
    icon: 'Award',
    color: 'blue',
    items: [
      'Single source of truth for all safety data',
      'Automated trend analysis and alerting',
      'Survey-ready documentation always current',
      'Connect dots across departments and sites'
    ]
  },
  {
    role: 'Executives & Owners',
    icon: 'Building2',
    color: 'purple',
    items: [
      'Board-ready dashboards and reports',
      'Risk visibility across the organization',
      'ROI tracking on safety investments',
      'Regulatory compliance confidence'
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "NikoSafe Connect transformed how we handle patient safety events. What used to take hours of paperwork now happens in real-time.",
    author: "Sarah M.",
    role: "Director of Quality",
    facility: "Regional Medical Center"
  },
  {
    id: 2,
    quote: "Ask Niko is like having a PhD-level infection preventionist available 24/7. Our staff get evidence-based answers instantly, with citations.",
    author: "Dr. James L.",
    role: "Chief Medical Officer",
    facility: "Community Hospital Network"
  },
  {
    id: 3,
    quote: "We passed our Joint Commission survey with zero deficiencies. Ask Niko helped us stay survey-ready every single day.",
    author: "Maria R.",
    role: "Compliance Officer",
    facility: "Long-Term Care Facility"
  }
];

export const stats = [
  { value: '94%', label: 'Faster Incident Reporting', description: 'Average time reduction' },
  { value: '67%', label: 'Fewer HAIs', description: 'In pilot facilities' },
  { value: '100%', label: 'Survey Readiness', description: 'Always current documentation' },
  { value: '4.9/5', label: 'User Satisfaction', description: 'From healthcare staff' }
];

export const chatSuggestions = [
  {
    category: 'Infection Prevention',
    icon: 'Shield',
    questions: [
      'What are the CLABSI prevention bundle elements?',
      'Show me hand hygiene protocols',
      'How do I report a suspected outbreak?'
    ]
  },
  {
    category: 'Patient Safety',
    icon: 'Heart',
    questions: [
      'How do I file a patient fall report?',
      'What is the medication error reporting process?',
      'Show me pressure injury prevention protocols'
    ]
  },
  {
    category: 'Quality & Compliance',
    icon: 'ClipboardCheck',
    questions: [
      'What are the Joint Commission requirements for restraints?',
      'Show me our infection control policies',
      'How do I document a tracer activity?'
    ]
  }
];

export const mockChatHistory = [
  {
    id: 1,
    role: 'assistant',
    content: `Hello! I'm **Ask Niko** — your Clinical Intelligence Engine with expertise beyond PhD-level across all healthcare disciplines.

I'm certified in Infection Prevention (CIC), Quality (CPHQ), Patient Safety (CPPS), and Risk Management (CPHRM). I've studied every protocol, reviewed every guideline, and I'm here to support you with evidence-based answers.

**How can I help you today?**

• 🔬 Infection Prevention protocols and outbreak support
• 🛡️ Patient Safety events and prevention strategies  
• ✅ Quality & Compliance guidance (Joint Commission, CMS)
• 📋 Facility policy interpretation
• 📊 Performance Improvement methodologies`,
    timestamp: new Date().toISOString()
  }
];

// Mock user for demo purposes
export const mockUser = {
  id: 'demo-user',
  name: 'Demo User',
  email: 'demo@nikosafeconnect.com',
  role: 'STAFF',
  department: 'Clinical',
  facility: 'Demo Healthcare Center'
};

// Navigation items
export const navItems = [
  { label: 'Features', href: '#features' },
  { label: 'Benefits', href: '#benefits' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' }
];
